import { initializeInfinite, scan, skipWhile, head } from "../fable_modules/fable-library.3.7.14/Seq.js";
import { equalArrays, equals, uncurry } from "../fable_modules/fable-library.3.7.14/Util.js";
import { GameObject__get_BasicGameObject, BasicGameObject__get_MapPosition, Game__get_PlayerMapPosition, Vector2D, Side } from "../Model.fs.js";
import { tryFind, item } from "../fable_modules/fable-library.3.7.14/List.js";

export function cast(setup, terminator, game) {
    const patternInput = setup();
    const rayDirection = patternInput[3];
    const posY = patternInput[2];
    const posX = patternInput[1];
    const mapX = (~(~posX)) | 0;
    const mapY = (~(~posY)) | 0;
    const deltaDistX = (rayDirection.vX === 0) ? 1.7976931348623157E+308 : Math.abs(1 / rayDirection.vX);
    const deltaDistY = (rayDirection.vY === 0) ? 1.7976931348623157E+308 : Math.abs(1 / rayDirection.vY);
    const halfStepDeltaX = (rayDirection.vX === 0) ? 1.7976931348623157E+308 : Math.sqrt(1 + (((rayDirection.vY * rayDirection.vY) / rayDirection.vX) * rayDirection.vX));
    const halfStepDeltaY = (rayDirection.vY === 0) ? 1.7976931348623157E+308 : Math.sqrt(1 + (((rayDirection.vX * rayDirection.vX) / rayDirection.vY) * rayDirection.vY));
    const patternInput_1 = (rayDirection.vX < 0) ? [-1, (posX - mapX) * deltaDistX] : [1, ((mapX + 1) - posX) * deltaDistX];
    const stepX = patternInput_1[0] | 0;
    const patternInput_2 = (rayDirection.vY < 0) ? [-1, (posY - mapY) * deltaDistY] : [1, ((mapY + 1) - posY) * deltaDistY];
    const stepY = patternInput_2[0] | 0;
    const patternInput_5 = head(skipWhile(terminator, scan(uncurry(2, (tupledArg) => {
        const isHit = tupledArg[0];
        const currentRayDistanceX = tupledArg[1];
        const currentRayDistanceY = tupledArg[2];
        const currentMapX = tupledArg[3] | 0;
        const currentMapY = tupledArg[4] | 0;
        const currentSide = tupledArg[5];
        return (_arg2) => {
            let matchValue, doorState, mapX2, mapY2, adjacent, rayMultiplier, rayPosition, trueDeltaX, trueDeltaY, halfStepInY, halfStepInX;
            if (!terminator([isHit, currentRayDistanceX, currentRayDistanceY, currentMapX, currentMapY, currentSide])) {
                return [isHit, currentRayDistanceX, currentRayDistanceY, currentMapX, currentMapY, currentSide];
            }
            else {
                const patternInput_3 = (currentRayDistanceX < currentRayDistanceY) ? [currentMapX + stepX, currentMapY, new Side(0)] : [currentMapX, currentMapY + stepY, new Side(1)];
                const newSide = patternInput_3[2];
                const newMapY = patternInput_3[1] | 0;
                const newMapX = patternInput_3[0] | 0;
                const patternInput_4 = (currentRayDistanceX < currentRayDistanceY) ? [currentRayDistanceX + deltaDistX, currentRayDistanceY] : [currentRayDistanceX, currentRayDistanceY + deltaDistY];
                return [(matchValue = item(newMapX, item(newMapY, game.Map)), (matchValue.tag === 3) ? false : ((matchValue.tag === 0) ? true : ((matchValue.tag === 1) ? ((doorState = item(matchValue.fields[0], game.Doors), (doorState.Status.tag === 2) ? false : ((mapX2 = (((posX < newMapX) ? (newMapX - 1) : newMapX) | 0), (mapY2 = (((posY > newMapY) ? (newMapY + 1) : newMapY) | 0), (adjacent = (equals(newSide, new Side(1)) ? (mapY2 - posY) : ((mapX2 - posX) + 1)), (rayMultiplier = (equals(newSide, new Side(1)) ? (adjacent / rayDirection.vY) : (adjacent / rayDirection.vX)), (rayPosition = (new Vector2D(posX + (rayDirection.vX * rayMultiplier), posY + (rayDirection.vY * rayMultiplier))), (trueDeltaX = ((halfStepDeltaX < 0.0001) ? 100 : halfStepDeltaX), (trueDeltaY = ((halfStepDeltaY < 0.0001) ? 100 : halfStepDeltaY), equals(newSide, new Side(0)) ? ((halfStepInY = (rayPosition.vY + ((stepY * Math.sqrt((trueDeltaX * trueDeltaX) - 1)) / 2)), (Math.floor(halfStepInY) === newMapY) && ((halfStepInY - newMapY) < (1 - (doorState.Offset / 64))))) : ((halfStepInX = (rayPosition.vX + ((stepX * Math.sqrt((trueDeltaY * trueDeltaY) - 1)) / 2)), (Math.floor(halfStepInX) === newMapX) && ((halfStepInX - newMapX) < (1 - (doorState.Offset / 64))))))))))))))) : patternInput[0]))), patternInput_4[0], patternInput_4[1], newMapX, newMapY, newSide];
            }
        };
    }), [false, patternInput_1[1], patternInput_2[1], mapX, mapY, new Side(0)], initializeInfinite((_arg1) => 0))));
    return [patternInput_5[0], deltaDistX, deltaDistY, patternInput_5[1], patternInput_5[2], patternInput_5[3], patternInput_5[4], patternInput_5[5]];
}

export function isPointInTriangle(p1, p2, p3, testPoint) {
    const a = (((p2.vY - p3.vY) * (testPoint.vX - p3.vX)) + ((p3.vX - p2.vX) * (testPoint.vY - p3.vY))) / (((p2.vY - p3.vY) * (p1.vX - p3.vX)) + ((p3.vX - p2.vX) * (p1.vY - p3.vY)));
    const b = (((p3.vY - p1.vY) * (testPoint.vX - p3.vX)) + ((p1.vX - p3.vX) * (testPoint.vY - p3.vY))) / (((p2.vY - p3.vY) * (p1.vX - p3.vX)) + ((p3.vX - p2.vX) * (p1.vY - p3.vY)));
    const c = (1 - a) - b;
    if (((((a >= 0) && (a <= 1)) && (b >= 0)) && (b <= 1)) && (c >= 0)) {
        return c <= 1;
    }
    else {
        return false;
    }
}

export function canTraverse(game, checkPlayer, mapX, mapY) {
    if ((((mapX < 0) ? true : (mapX > 63)) ? true : (mapY < 0)) ? true : (mapY > 63)) {
        return false;
    }
    else if (checkPlayer && equalArrays([mapX, mapY], Game__get_PlayerMapPosition(game))) {
        return false;
    }
    else {
        const cell = item(mapX, item(mapY, game.Map));
        if ((cell.tag === 1) ? (item(cell.fields[0], game.Doors).Status.tag === 2) : (!(cell.tag === 0))) {
            return tryFind((go) => {
                if (equalArrays(BasicGameObject__get_MapPosition(GameObject__get_BasicGameObject(go)), [mapX, mapY])) {
                    return GameObject__get_BasicGameObject(go).Blocking;
                }
                else {
                    return false;
                }
            }, game.GameObjects) == null;
        }
        else {
            return false;
        }
    }
}

export function canPlayerTraverse(game, pos_0, pos_1) {
    const pos = [pos_0, pos_1];
    return canTraverse(game, false, pos[0], pos[1]);
}

export function canEnemyTraverse(game, pos_0, pos_1) {
    const pos = [pos_0, pos_1];
    return canTraverse(game, true, pos[0], pos[1]);
}

